import { WhiteboardControlMenuItemWrapper as WhiteboardControlMenuItem } from "../../session/controls/WhiteboardControl";
import { ScreenShareMenuItemsWrapper as ScreenShareMenuItems } from "../../session/controls/ScreenShareControl";
import { useIsZoomEnabled } from "../../hooks/useIsZoomEnabled";

export function SessionModeControlMenuItemsWrapper() {
  const [isZoomEnabled] = useIsZoomEnabled();

  // Whiteboarding is not scoped for the initial Zoom launch, but will be added
  // later.
  if (isZoomEnabled) {
    return <ScreenShareMenuItems />;
  }

  return (
    <>
      <ScreenShareMenuItems />
      <WhiteboardControlMenuItem />
    </>
  );
}
